module.exports = __webpack_public_path__ + "static/img/新华三 H3C BE18000.e6db14b7.png";